import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BasicLayout } from "../../modules/Layouts/basicLayout";
import BasicHeaderDocumentos from "./Components/BasicHeader";
import { State } from "../../reducers";
import BasicFooterDocumentos from "./Components/BasicFooterDocument";
import ModalDelete from "../../components/Modals/Generales/ModalDelete";
import ModalEditarProducto from "./Components/NotaRemision/ModalEditarProducto";
import ModalConfirm from "../../components/Modals/Generales/ModalConfirm";
import ModalDTEEmitido from "./Components/ModalDTEEmitido";
import ModalSendEmailDTE from "./Components/ModalSendEmailDTE";
import ModalImprimirFactura from "../../components/Modals/ModalsFacturacion/ModalImprimirFactura";
import ModalAnularDTE from "./Components/ModalAnularDTE";
import ModalClienteEncontradoDTE from "./Components/BasicModalClienteEncontradoDTE";
import './styles/credito-fiscal.style.css'
import useFacturaExportacion from "../../actions/factura-exportacion.actions";
import FormulariosFE from "./Components/NotaRemision/FormulariosFE";
import DTEFacturaExportacion from "./Components/DTE/DTEFacturaExportacion";
import ModalSalir from "../../components/Modals/Generales/ModalConfirmSalir";
import { unirChipsArray } from "../../utils/strings.utils";

export default function FacturaExportacion (){
    const [imprimirComoTicket, setImprimirComoTicket] = useState(false)
    const {
        view, 
        formCliente, 
        modal_quitarTodo,
        modal_editar,
        modal_eliminar,
        modal_emitir,
        modal_emitido,
        modal_masOpciones,
        modal_enviarCorreo,
        modal_imprimir,
        modal_anulado,
        modal_anular,
        modal_clienteEncontrado,

        productoEdit,
        clienteEncontrado,

        errorsProducto,
        response_QRcode,
        response_Emitir,
        blockedData,
        unidades
    } = useSelector((state: State) => state.facturaExportacion)
    const {
        cargarSucursales, 
        footer_textButtons, 
        footer_onClickBack, 
        footer_onClickNext, 
        button_onClickQuitarTodo, 
        modal_cerrarQuitarTodo,
        modal_cerrarModalEliminar,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_cerrarModalEditar,
        modal_cerrarEmitir,

        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_cerrarMasOpciones,
        modal_button_cerrarModalEmitido,
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,

        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_cerrarImprimir,

        modal_button_anular,
        modal_cerrarAnular,
        modal_button_onConfirmAnular,
        modal_button_anular2,
        modal_button_descargarJson,

        modal_cerrarClienteEncontrado,
        modal_button_aceptarClienteEncontrado,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
    } = useFacturaExportacion()

    const { config } = useSelector((state: State) => state.userLogin)

    const enContingencia = !modal_masOpciones && response_Emitir?.esContingencia === true

    return (
        <BasicLayout>
            <ModalSalir 
                excludeValidate={formCliente.loadedSucursal && (!formCliente.datosSucursal || formCliente.datosSucursal?.length == 0)} 
                title="Salir de factura de exportación" 
                onConfirmExit={modal_button_emitirNuevo}
            />
            {(modal_emitido || modal_masOpciones) && 
                <ModalDTEEmitido 
                    title = {modal_masOpciones ? 'Más opciones' : enContingencia ? '¡Factura de exportación emitida en contingencia!' : '¡Factura de exportación emitida!'}
                    enContingencia={enContingencia}
                    onClickNuevo={modal_button_emitirNuevo}
                    onClickAnular={modal_button_anular}
                    onClickCerrar={modal_cerrarMasOpciones}
                    onClickDownloadExcel={modal_button_descargarExcel}
                    onClickDownloadImage={modal_button_descargarImagen}
                    onClickDownloadPDF={modal_button_descargarPDF}
                    onClickEmail={modal_button_enviarCorreo}
                    onClickPrint={() => { setImprimirComoTicket(false); modal_button_imprimir() }}
                    onClickVerDetalle={modal_button_verDetalle}
                    onClickDownloadJson={modal_button_descargarJson}
                    verDetalle = {false}
                    qrImage={response_QRcode}
                    ticketHabilitado={config?.tickethabilitado}
                    onClickPrintTicket={() => { setImprimirComoTicket(true); modal_button_imprimirTicket() }}
                    onClickDownloadPDFTicket={modal_button_descargarPDFTicket}
                />
            }
            {modal_imprimir && <ModalImprimirFactura documento={response_Emitir?.JsonFactura} sello={response_Emitir?.Sello} modoTicket={imprimirComoTicket} onCancel={modal_cerrarImprimir} onPrint={modal_cerrarImprimir}/>}
            {modal_enviarCorreo && <ModalSendEmailDTE chipsEmail={unirChipsArray(formCliente.chipsEmail, formCliente.email)} onClickBack={modal_button_cerrarEnviarCorreo} onClickSend={modal_button_onClickEnviarCorreo}/>}
            {modal_emitir && <ModalConfirm title = 'Emitir factura de exportación' detail = '¿Estás a punto de emitir esta factura de exportación ¿deseas continuar?' closeModalConfirm = {modal_cerrarEmitir} actionConfirm = {modal_button_emitirDocumento} messageAction = 'Emitir'/>}
            {modal_eliminar && <ModalDelete title = 'Quitar producto' detail = '¿Seguro que quieres quitar este producto? Esta acción no se puede deshacer.' closeModalDelete = {modal_cerrarModalEliminar} actionDelete = {modal_button_onConfirmEliminar}/>}
            {modal_editar && <ModalEditarProducto dteCode="11" facturaExportacion unidades = {unidades} errors = {errorsProducto} formProducto = {productoEdit} onChangeFormProducto = {modal_onChangeFormProductoEdit} onChangeSelectCatalogoProducto={modal_onChangeSelectCatalogoProductoEdit} onClickCerrarModalEditarProducto = {modal_cerrarModalEditar} onClickActualizarProducto = {modal_button_onConfirmEdit}/>}
            {modal_quitarTodo && <ModalDelete title = 'Quitar todo' detail = '¿Seguro que quieres quitar todos los productos de esta lista? Esta acción no se puede deshacer.' actionDelete = {button_onClickQuitarTodo} closeModalDelete = {modal_cerrarQuitarTodo}/>}
            {modal_anular && <ModalAnularDTE title="Anular factura de exportación" warning='Estás a punto de anular esta factura de exportación ¿deseas continuar?' onCancel={modal_cerrarAnular} actionConfirm={modal_button_onConfirmAnular}/>}
            {/* {modal_anular && <ModalAnularFactura2 closeModalEliminar = {modal_cerrarAnular} actionEliminar = {modal_button_anular2}/>} */}
            {modal_clienteEncontrado && <ModalClienteEncontradoDTE infoCliente = {clienteEncontrado} onClickCancel = {modal_cerrarClienteEncontrado} onClickConfirm = {modal_button_aceptarClienteEncontrado}/>}
            <BasicHeaderDocumentos title="Factura de exportación" url="/otros-documentos"/>
            {renderView(view)}  
            <BasicFooterDocumentos emitirNuevo = {view === 'Detalle' ? 'Emitir nuevo' : false} onEmitirNuevo={modal_button_emitirNuevo} textBack={footer_textButtons().back.text} imgBack={footer_textButtons().back.icon} textNext={footer_textButtons().next.text} imgNext={footer_textButtons().next.icon} onClickBack={footer_onClickBack} onClickNext={footer_onClickNext}/>          
        </BasicLayout>
    )
}

const renderView = (view: string) => {
    switch(view){
        case 'Formularios':
            return <FormulariosFE/>
        case 'Previsualizacion':
        case 'Detalle':
            return <DTEFacturaExportacion/>
    }
}